'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.collapsibleWidget = function () {
	return mmWidgets.each(this, function () {
		const widget = this;
		widget.find('[data-mm-role~=collapsible-header]').on('click', () => {
			widget.toggleClass('collapsed');
		});
	});
};


